export default "__VITE_ASSET__JoDxeQ1xEKeZpTWUJ7TFQw__";